import BackendDeveloperPage from "./BackendDeveloperPage";

export default function JavaDeveloperPage() {
  return <BackendDeveloperPage technology="java" />;
}
